import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import Joyride from 'react-joyride';
import Block from './WorkflowComponents/Block';
import BlockChart from './WorkflowComponents/BlockChart';
import BlocksSelector from './WorkflowComponents/BlocksSelector'
import WorkflowShares from './WorkflowComponents/WorkflowShares'
import ConfirmationPopup from '../components/ConfirmationPopup'

import { postJson, putJson, getJson } from '../helpers/RequestsHelper';
import { getActions, supportedApps } from '../helpers/applications';

class Workflow extends Component {
    onboarding = {
        "template": [
            {
                target: '#saveButton',
                disableBeacon: true,
                content: 'Using this button you can save the workflow. You can always come back to edit it.',
            }
        ]
    }
    getClearState() {
        return {
            title: "",
            blocks: [
                {
                    id: "block_0",
                    type: "start",
                    application: "simplyflows_schedule",
                    action: { id: "schedule", name: "Schedule" },
                    label: "Every 15 minutes",
                    row: 0,
                    col: "s",
                    tested: true,
                    params: { cron: { tab: "Minutes", value: "0 0/15 * * * ?", text: "Every 15 minutes" } }
                },
            ],
            connections: [
            ],
            rowsCount: 1,
            nextIndex: 1,
            _id: undefined,
            loading: true,
            createdOn: undefined,
            tested: false,
            customLayout: false,
            customTitle: false,
            live: false
        }
    }
    state = this.getClearState()
    DRAFT = 1
    TEMPLATE = 2

    constructor() {
        super()
        this.onAddBlock = this.onAddBlock.bind(this)
        this.onInsertBlock = this.onInsertBlock.bind(this)
        this.onDeleteBlock = this.onDeleteBlock.bind(this)
        this.onMergeBlock = this.onMergeBlock.bind(this)
        this.onConnectBlock = this.onConnectBlock.bind(this)
        this.onSave = this.onSave.bind(this)
        this.drop = this.drop.bind(this)
        this.allowDrop = this.allowDrop.bind(this)
        this.updateBlock = this.updateBlock.bind(this)
        this.setMergeMode = this.setMergeMode.bind(this)
        this.setConnectMode = this.setConnectMode.bind(this)

        this.loadWorkflow = this.loadWorkflow.bind(this)
        this.initializeState = this.initializeState.bind(this)
        this.loadBlocksAndSetState = this.loadBlocksAndSetState.bind(this)

        this.workflowRef = React.createRef();
        this.workflowScrollPaneRef = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        if (state.loading) {// && !state.observerAttached && !props.match.params.id) {
            var previousState = sessionStorage.getItem("workflowState")
            if (previousState) {
                let state = JSON.parse(previousState)
                state.loadedFromStorage = true
                return state
            }
        }
        return state
    }

    componentDidMount() {
        const { t } = this.props;
        document.title = t("titleappname") + t("title_workflow")
        this.initializeState();
    }

    componentDidUpdate() {
        //this.initializeState();
        //TODO: Is this the best approach?
        if (!this.state.observerAttached && !this.state.loading) {
            const resizeObserver = new ResizeObserver((elements) => {
                this.setState({ canvasWidth: elements[0].clientWidth, canvasHeight: elements[0].clientHeight });
            })

            resizeObserver.observe(this.workflowRef.current)
            this.setState({ observerAttached: true })
        }
        if (this.props.match.params.id === "new") {
            this.initializeState()
        }

        if (this.state.onboarding != this.props.onboarding) {
            this.setState({ onboarding: this.props.onboarding })
        }

        if (this.layoutElements(this.state.blocks, this.state.connections, !this.state.customTitle)) {
            this.refreshKey++
        }
    }

    initializeState() {
        if (this.props.match.params.id) {
            sessionStorage.removeItem("workflowState")

            if (this.props.match.params.id === "new") {
                let newState = this.getClearState()
                newState.loading = false
                this.setState(newState, () => this.loadBlocksAndSetState(this.state));
                this.props.history.push("/workflow")
            } else {
                this.setState(this.getClearState(), () => this.loadWorkflow(this.props.match.params.id));
            }
        } else if (this.props.match.params.templateId) {
            sessionStorage.removeItem("workflowState")

            this.setState(this.getClearState(), () => this.loadTemplate(this.props.match.params.templateId));
        } else if (this.props.match.params.copyId) {
            sessionStorage.removeItem("workflowState")

            this.setState(this.getClearState(), () => this.loadCopy(this.props.match.params.copyId));
        } else {
            this.loadBlocksAndSetState(this.state)
        }
    }

    async loadTemplate(templateId) {
        let template = await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/templates/" + templateId)
        const maxRowIndex = template.blocks.reduce((maxRow, b) => maxRow < b.row ? b.row : maxRow, 0)
        template.blocks[0].tested = true
        template.blocks[0].label = "Every 15 minutes"
        template.blocks[0].params = { cron: { tab: "Minutes", value: "0 0/15 * * * ?", text: "Every 15 minutes" } }

        template.customTitle = true
        template.rowsCount = maxRowIndex
        template.nextIndex = template.blocks.length + 1
        template.loading = false

        for (let i = 0; i < template.blocks.length; i++) {
            const block = template.blocks[i]
            if (block.application) {
                const actions = await getActions(block.application)
                if (block.action) {
                    block.action = actions.blocks.find(a => a.id === block.action.id)
                }
            } else {
                block.tested = true
            }

            var searchParams = new URLSearchParams(window.location.search)
            if (searchParams) {
                const blockParams = searchParams.get(block.id + "_params");
                if (blockParams) {
                    block.params = JSON.parse(blockParams)

                    //To use it URL encode the params 
                    //https://localhost/workflow/template/screener_detectleader_sendemail?onboarding=template&tested=true&block_0_params=%7B%22fields%22%3A%7B%22field%22%3A%22%7B%7BusdNetVolume.activity%3AScreener%3A%24ref%7D%7D%22%7D%7D&block_1_params=%7B%22subject%22%3A%20%22%7B%7Bsymbol%3AScreener%3Atext%7D%7D%20is%20the%20new%20leader%22%7D
                }

                if (searchParams.get("tested") == "true") {
                    block.tested = true
                    this.updateTested()
                }
            }
        }

        this.updateState(template)

        this.props.history.push("/workflow")
    }

    async loadWorkflow(workflowId) {
        const workflow = await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/" + workflowId)

        await this.loadBlocksAndSetState(workflow);
    }

    async loadCopy(workflowId) {
        const workflow = await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows/" + workflowId)
        delete workflow._id

        await this.loadBlocksAndSetState(workflow);
    }

    async loadBlocksAndSetState(workflow) {
        for (let i = 0; i < workflow.blocks.length; i++) {
            const block = workflow.blocks[i]
            if (block.application) {
                const actions = await getActions(block.application)
                if (block.action) {
                    block.action = actions.blocks.find(a => a.id === block.action.id)
                }
            }
        }

        workflow.loading = false

        this.setState(workflow)
    }

    updateState(newState) {
        this.setState(newState, () => { this.storeState(); this.updateTested() })
    }

    updateTested() {
        let tested = false

        if (this.state.blocks.length <= 1 ||
            this.state.title.length === 0 ||
            this.state.blocks.find(a => !a.tested)) {
            tested = false
        }
        else {
            tested = true
        }

        if (tested !== this.state.tested) {
            this.setState({ tested }, this.storeState)
        } else {
            this.storeState()
        }
    }

    storeState() {
        let saveState = this.trimState();
        sessionStorage.setItem("workflowState", JSON.stringify(saveState))
    }

    async onSave(kind) {
        if (kind == this.TEMPLATE) {
            var template = this.createTemplateFromWorkflow(this.state);
            const result = await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/templates", template)
            if (result.error) {
                //TODO: Error
            }

            sessionStorage.removeItem("workflowState");
            this.props.history.push("/templates")
        } else {
            let saveState = this.trimState(kind);
            if (this.state._id) {
                await putJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows", saveState)
            } else {
                const result = await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/workflows", saveState)
                if (result.error) {
                    //TODO: Error
                }
            }

            sessionStorage.removeItem("workflowState")
            this.props.history.push("/workflows")
        }
    }

    createTemplateFromWorkflow(workflow) {
        let saveState = {
            title: workflow.title,
            user: true
        }
        saveState.blocks = workflow.blocks.map(block => {
            let newBlock = {
                id: block.id,
                type: block.type,
                label: block.label,
                row: block.row,
                col: block.col
            }

            if (block.application) {
                newBlock.application = block.application
            }
            if (block.action) {
                newBlock.action = block.action.id
            }

            return newBlock
        })
        saveState.connections = workflow.connections

        return saveState;
    }

    trimState(kind) {
        let saveState = { ...this.state };
        saveState.blocks = saveState.blocks.map(block => {
            let newBlock = { ...block }
            if (newBlock.action) {
                const actionId = newBlock.action.id;
                delete newBlock.action;
                //TODO: Replace this on the server
                newBlock.action = { id: actionId };
            }
            delete newBlock["actions"];
            delete newBlock["types"];
            delete newBlock["inputTypes"];
            return newBlock
        });
        delete saveState.loading;
        delete saveState.mergeMode;
        delete saveState.connectMode;
        delete saveState.observerAttached;
        delete saveState.focusedBlock;
        delete saveState.focusedBlock;
        delete saveState.onboarding;

        if (kind == this.DRAFT) {
            saveState.draft = true
            saveState.live = false
        } else {
            delete saveState.draft
        }

        return saveState;
    }

    updateBlock(updatedBlock) {
        let blocks = this.state.blocks
        const blockIndex = blocks.findIndex((a) => a.id === updatedBlock.id)
        var oldBlock = blocks[blockIndex]
        var oldAction = oldBlock.action
        var newAction = updatedBlock.action
        if (oldBlock.application !== updatedBlock.application
            || oldAction && !newAction
            || !oldAction && newAction
            || oldAction && newAction && oldAction.id !== newAction.id
            || updatedBlock.needChildrenReset
        ) {
            delete updatedBlock.needChildrenReset
            //reset params for children blocks, if we have fields used there
            var childrenConnections = this.state.connections.filter(a => a.from == oldBlock.id)
            for (let index = 0; index < childrenConnections.length; index++) {
                const childrenConnection = childrenConnections[index]

                const childBlock = blocks.find(a => a.id == childrenConnection.to)

                //If we keep the params we can have unexpected results 
                delete childBlock.params
                delete childBlock.label
                childBlock.tested = false
                // if (childBlock.params) {
                //     removeFieldsUsedInParams(childBlock.params)
                // }
            }
        }
        blocks[blockIndex] = updatedBlock

        this.layoutElements(blocks, this.state.connections, !this.state.customTitle)
        let newState = {}
        if (updatedBlock.type === "input") {
            newState.focusedBlock = updatedBlock
        }

        this.updateState(newState)

    }

    setMergeMode(block) {
        this.setState({ mergeMode: { block } })
    }

    setConnectMode(block) {
        this.setState({ connectMode: { block } })
    }



    onAddBlock(block) {
        let blocks = this.state.blocks
        let connections = this.state.connections

        const rowIndex = block.row + 1
        const rowBlocks = blocks.filter(a => a.row === rowIndex && a.col.startsWith(block.col + "."))

        let newBlock = { id: "block_" + this.state.nextIndex, row: rowIndex, col: block.col + "." + (rowBlocks.length + 1) }
        blocks.push(newBlock)
        connections.push({ from: block.id, to: newBlock.id })

        if (this.state.customLayout) {
            newBlock.top = block.top + block.height + 50//TODO: Global constant for blockPadding
            newBlock.left = block.left
        }

        this.layoutElements(blocks, connections, !this.state.customTitle)

        this.updateState({ blocks, connections, rowsCount: rowIndex + 1 > this.state.rowsCount ? rowIndex + 1 : this.state.rowsCount, nextIndex: this.state.nextIndex + 1, focusedBlock: newBlock })
    }


    onInsertBlock(connection) {
        let blocks = this.state.blocks
        let connections = this.state.connections
        const fromBlock = blocks.find(a => a.id === connection.from)
        const toBlock = blocks.find(a => a.id === connection.to)

        const colSuffix = ".1"

        //Move all rows after the current one down        
        const colIndex = toBlock.col
        blocks.filter(a => a.row >= toBlock.row && a.col.startsWith(toBlock.col)).forEach(a => {
            a.row = a.row + 1;
            a.col = a.col.slice(0, colIndex.length) + colSuffix + a.col.slice(colIndex.length)
        })

        let newBlock = { id: "block_" + this.state.nextIndex, row: fromBlock.row + 1, col: colIndex }
        blocks.push(newBlock)

        connections.push({ from: newBlock.id, to: toBlock.id })

        let oldConnection = connections.find(a => a.from === connection.from && a.to === connection.to)
        oldConnection.to = newBlock.id

        this.layoutElements(blocks, connections, !this.state.customTitle)

        this.updateState({ blocks, connections, rowsCount: this.state.rowsCount + 1, nextIndex: this.state.nextIndex + 1, focusedBlock: newBlock })
    }

    onDeleteBlock(block) {
        let blocks = this.state.blocks
        let connections = this.state.connections

        //Remove connections
        const parentConnection = connections.find(a => a.to === block.id)
        connections.splice(connections.indexOf(parentConnection), 1)

        //Remove block        
        const blockInArray = blocks.find(a => a.id === block.id)
        blocks.splice(blocks.indexOf(blockInArray), 1)

        //Move all rows after the current one up        
        const colIndex = block.col
        const previousColIndex = colIndex.substring(0, colIndex.lastIndexOf("."))
        blocks.filter(a => a.row >= block.row && a.col.startsWith(colIndex)).forEach(a => {
            a.row = a.row - 1;
            a.col = a.col.replace(colIndex, previousColIndex)
        })

        let removeConnections = []
        //Change all children connections to start from the parent, if they don't have any other connection
        for (let i = connections.length - 1; i >= 0; i--) {
            const a = connections[i];
            if (a.from === block.id) {
                if (connections.find(b => b.to === a.to && b.from !== block.id)) {
                    removeConnections.push(i)
                } else {
                    a.from = parentConnection.from
                }
            }
        }

        for (let i = 0; i < removeConnections.length; i++) {
            const removeIndex = removeConnections[i];
            connections.splice(removeIndex, 1)
        }

        this.layoutElements(blocks, connections, !this.state.customTitle)

        const maxRowIndex = blocks.reduce((maxRow, b) => maxRow < b.row ? b.row : maxRow, 0)

        this.updateState({ blocks, connections, rowsCount: maxRowIndex + 1 })
    }

    onMergeBlock(block) {
        if (block) {
            let blocks = this.state.blocks
            let connections = this.state.connections

            connections.push({ from: block.id, to: this.state.mergeMode.block.id })

            this.layoutElements(blocks, connections, !this.state.customTitle)

            this.updateState({ connections, mergeMode: undefined })
        } else {
            this.updateState({ mergeMode: undefined })
        }
    }

    onConnectBlock(block) {
        if (block) {
            let blocks = this.state.blocks
            let connections = this.state.connections

            if (connections.find(a => a.to == block.id && a.from == this.state.connectMode.block.id)) {
                connections = connections.filter(a => a.to != block.id || a.from != this.state.connectMode.block.id)
            } else {
                connections.push({ to: block.id, from: this.state.connectMode.block.id })
            }

            this.layoutElements(blocks, connections, !this.state.customTitle)

            this.updateState({ connections, connectMode: undefined })
        } else {
            this.updateState({ connectMode: undefined })
        }
    }


    layoutElements(blocks, connections, updateTitle) {
        let title = ""
        let changed = false
        if (this.workflowRef.current) {
            //const canvasWidth = this.workflowRef.current.clientWidth
            //const canvasWidth = this.workflowScrollPaneRef.current.scrollWidth
            //const blockWidth = 200
            const blockPadding = 50
            const blockHeight = 70

            const offsetTop = this.workflowRef.current.offsetTop
            const offsetLeft = this.workflowRef.current.offsetLeft

            let top = offsetTop;

            let chartWidth = 0
            let chartHeight = 0
            let chartTop = offsetTop

            //Initialize size of the blocks
            blocks.forEach(b => {
                if (!b.width) b.width = 300
                b.height = blockHeight
            })

            for (let rowIndex = 0; rowIndex <= this.state.rowsCount; rowIndex++) {
                const rowBlocks = blocks.filter(a => a.row === rowIndex).sort((a, b) => a.col.localeCompare(b.col))
                const rowWidth = rowBlocks.reduce((a, b) => a + b.width, 0) + (rowBlocks.length - 1) * blockPadding
                for (let i = 0; i < rowBlocks.length; i++) {
                    const rowBlock = rowBlocks[i];
                    if (rowBlock.left && this.state.customLayout) {
                        if (rowBlock.left + rowBlock.width > chartWidth) {
                            chartWidth = rowBlock.left + rowBlock.width - offsetLeft
                        }
                    } else if (rowWidth > chartWidth) {
                        chartWidth = rowWidth
                    }
                    if (rowBlock.top && this.state.customLayout) {
                        if (rowBlock.top + rowBlock.height > chartHeight) {
                            chartHeight = rowBlock.top + rowBlock.height - offsetTop + 100//leave some place to drag an element down
                        }
                    }
                }

                //TODO: initialize row height and width here and save them
            }

            if (!this.state.customLayout) {
                chartHeight = this.state.rowsCount * (blockHeight + blockPadding) + 100
            }

            let chartLeft = offsetLeft + (this.workflowRef.current.clientWidth - chartWidth) / 2

            if (chartLeft < offsetLeft) {
                chartLeft = offsetLeft
            }

            for (let rowIndex = 0; rowIndex <= this.state.rowsCount; rowIndex++) {
                const rowBlocks = blocks.filter(a => a.row === rowIndex).sort((a, b) => a.col.localeCompare(b.col))
                const totalWidth = rowBlocks.reduce((a, b) => a + b.width, 0) + (rowBlocks.length - 1) * blockPadding

                let rowHeight = 0
                let left = (chartWidth - totalWidth) / 2 + chartLeft
                for (let i = 0; i < rowBlocks.length; i++) {
                    let block = rowBlocks[i]
                    if (!this.state.customLayout) {
                        block.top = top
                        block.left = left
                    }
                    block.style = {
                        backgroundColor: "white",
                        position: "absolute",
                        width: block.width + "px",
                        height: block.height + "px",
                        top: block.top + "px",
                        left: block.left + "px",
                    }
                    left += block.width + blockPadding

                    if (updateTitle) {
                        title = this.getBlockTitle(block, title);
                    }
                    if (rowHeight < block.height) rowHeight = block.height
                }

                top += rowHeight + blockPadding
            }

            for (let i = 0; i < connections.length; i++) {
                const connection = connections[i];

                const fromBlock = blocks.find(a => a.id === connection.from)
                const toBlock = blocks.find(a => a.id === connection.to)


                //TODO: Add smarter detection
                if (fromBlock.row >= toBlock.row) {
                    const start = {
                        x: fromBlock.left + fromBlock.width - chartLeft,
                        y: fromBlock.top + fromBlock.height - offsetTop
                    }

                    const end = {
                        x: toBlock.left + toBlock.width / 2 - chartLeft,
                        y: toBlock.top - offsetTop - 2
                    }

                    if (!connection.start || connection.start.x !== start.x || connection.start.y !== start.y
                        || !connection.end || connection.end.x !== end.x || connection.end.y !== end.y) {

                        const detour = [{
                            x: fromBlock.left + fromBlock.width * 1.5 - chartLeft,
                            y: fromBlock.top + fromBlock.height - offsetTop
                        },
                        {
                            x: fromBlock.left + fromBlock.width * 1.5 - chartLeft,
                            y: toBlock.top - offsetTop - 100
                        }
                        ]

                        connection.line = { start, end, detour }
                        changed = true
                    }
                } else {
                    const start = {
                        x: fromBlock.left + fromBlock.width / 2 - chartLeft,
                        y: fromBlock.top + fromBlock.height - offsetTop
                    }

                    const end = {
                        x: toBlock.left + toBlock.width / 2 - chartLeft,
                        y: toBlock.top - offsetTop - 2
                    }

                    if (!connection.start || connection.start.x !== start.x || connection.start.y !== start.y
                        || !connection.end || connection.end.x !== end.x || connection.end.y !== end.y) {
                        connection.line = { start, end }
                        changed = true
                    }
                }
            }

            //const chartHeight = top - offsetTop;
            if (this.state.chartHeight !== chartHeight || this.state.chartWidth !== chartWidth || this.state.chartTop !== chartTop || this.state.chartLeft !== chartLeft) {
                this.setState({ chartHeight, chartWidth, chartTop, chartLeft })
            }
        }
        if (updateTitle && title !== this.state.title) {
            this.setState({ title })
        }
        if (this.state.forceLayout) {
            this.setState({ forceLayout: false })
        }
        return changed
    }

    drop = (e) => {

        e.preventDefault();
        var id = e.dataTransfer.getData("id");
        var startX = e.dataTransfer.getData("startX");
        var startY = e.dataTransfer.getData("startY");

        let blocks = this.state.blocks

        let block = blocks.find(a => a.id === id)

        if (block) {
            //We use the delta to position the element exactly where it is dropped, not where the cursor is
            block.top += e.clientY - startY
            block.left += e.clientX - startX

            this.setState({ blocks, customLayout: true, forceLayout: true })
        }
    }

    allowDrop = (e) => {
        //TODO: Allow to drop only my elements
        e.preventDefault();
    }

    getBlocksToMerge = (selectedBlock) => {
        let mergeBlocks = []
        //Exclude row 0, as we don't merge with start
        //TODO: Should we allow cycles?
        for (let i = 1; i < this.state.blocks.length; i++) {
            const block = this.state.blocks[i];

            //Exclude all rows under the selected block
            if (block.row > selectedBlock.row) {
                continue
            }

            //Exclude current block
            if (block.id === selectedBlock.id) {
                continue
            }

            //Check for existing connection
            if (this.state.connections.find(a => a.from === block.id && a.to === selectedBlock.id)) {
                continue
            }

            mergeBlocks.push(block)
        }
        return mergeBlocks
    }

    getBlockTitle(block, title) {
        if (!supportedApps) {
            return ""
        }
        //TODO: Move it somewhere else
        if (block.action) {
            var application = supportedApps.find(a => a.id === block.application);
            var text = "(" + application.name + ") "
            if (block.label) {
                text += block.label
            } else {
                text += block.action.name;
            }
            return title ? title + ", " + text : text;
        } else if (block.label) {
            return title ? title + ", " + block.label : block.label;
        }
        return title;
    }

    render() {

        const { t } = this.props;
        if (this.state.loading) {
            return <div className="spinner-border" role="status">
                <span className="sr-only">{t("loading")}</span>
            </div>
        }

        let workflowBlocks = this.state.blocks.map(block =>
            <div style={block.style} key={"d" + block.id + block.top + block.left}>
                {block.action && block.action.id === "merge"
                    ? <Block block={block} key={block.id + block.top + block.left} onAddBlock={this.onAddBlock} onDeleteBlock={this.onDeleteBlock} focusedBlock={this.state.focusedBlock} workflow={this.state} updateBlock={this.updateBlock} setMergeMode={this.setMergeMode} mergeBlocks={this.getBlocksToMerge(block)} onActionChange={this.onActionChange} isLegacy={this.props.isLegacy} />
                    : <Block block={block} key={block.id + block.top + block.left} onAddBlock={this.onAddBlock} onDeleteBlock={this.onDeleteBlock} focusedBlock={this.state.focusedBlock} workflow={this.state} updateBlock={this.updateBlock} setConnectMode={this.setConnectMode} isLegacy={this.props.isLegacy} />}
            </div>
        )

        let mergeSelectorStyle = {}
        let mergeBlocks = []
        let canvasStyle = {}
        let canvasWidth = 0
        let canvasHeight = 0

        if (this.workflowRef.current) {
            canvasHeight = this.state.chartHeight
            canvasWidth = this.state.chartWidth
            canvasStyle = {
                //backgroundColor: "#00000007",
                position: "absolute",
                width: this.state.chartWidth + "px",
                height: this.state.chartHeight + "px",
                top: this.state.chartTop + "px",
                left: this.state.chartLeft + "px"
            };
            if (this.state.mergeMode) {
                mergeSelectorStyle = {
                    position: "absolute",
                    width: this.state.chartWidth + "px",
                    height: this.state.chartHeight + "px",
                    top: this.state.chartTop + "px",
                    left: this.state.chartLeft + "px"
                };
                mergeBlocks = this.getBlocksToMerge(this.state.mergeMode.block)
            }

            if (this.state.connectMode) {
                mergeSelectorStyle = {
                    position: "absolute",
                    width: this.state.chartWidth + "px",
                    height: this.state.chartHeight + "px",
                    top: this.state.chartTop + "px",
                    left: this.state.chartLeft + "px"
                };
                mergeBlocks = this.getBlocksToMerge(this.state.connectMode.block)
            }
        }

        console.log("workflow", this.props.isLegacy)

        //TODO: Find how to rerender connections, don't rely on count
        return (
            <div>
                <h2><textarea id="workflowTitle" className="form-control" value={this.state.title} onChange={(e) => this.setState({ customTitle: true, title: e.target.value.trimStart() }, this.updateTested)} placeholder={t("tip_workflow_title")} /></h2>
                <div ref={this.workflowRef} className="workflow" onDrop={this.drop} onDragOver={this.allowDrop} >
                    {/* <div className="workflowScrollPane"  ref={this.workflowScrollPaneRef}  > */}
                    <table className="workflow" id="workflow" width={canvasWidth} height={canvasHeight} >
                        <tbody><tr><td width={canvasWidth} height={canvasHeight}>
                            <BlockChart canvasStyle={canvasStyle} connections={this.state.connections} onInsertBlock={this.onInsertBlock} canvasWidth={canvasWidth} canvasHeight={canvasHeight} />
                            {workflowBlocks}
                        </td></tr></tbody>
                    </table>
                    {this.state.mergeMode ? <BlocksSelector style={mergeSelectorStyle} width={canvasWidth} height={canvasHeight} blocks={mergeBlocks} onSelect={this.onMergeBlock} /> : ""}
                    {this.state.connectMode ? <BlocksSelector style={mergeSelectorStyle} width={canvasWidth} height={canvasHeight} blocks={mergeBlocks} onSelect={this.onConnectBlock} /> : ""}
                </div>
                <div className="d-flex justify-content-center">
                    {this.state.blocks.length <= 1 ? <>Not sure what to do? You can use some of our&nbsp;<a href='/templates'>templates</a>&nbsp;as a starting point. <br /><br /></> : <></>}
                </div>
                {this.props.windowWidth > 993 ?
                    <div className="d-flex" style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>
                        {this.props.match.params.id ?
                            <WorkflowShares workflowId={this.props.match.params.id} />
                            : ""}
                        <div className="p-2">
                            <button className="submit-btn" onClick={this.onSave} disabled={!this.state.tested} id="saveButton">Save Workflow</button>
                        </div>
                        <div className="p-2">
                            <button className="submit-btn" onClick={() => this.onSave(this.DRAFT)} disabled={this.state.blocks.length <= 1}>Save Draft</button>
                        </div>
                        <div className="p-2">
                            <button className="submit-btn" onClick={() => this.setState({ showSaveAsTemplateWarning: true })} disabled={this.state.blocks.length <= 1}>Save as Template</button>
                            <ConfirmationPopup show={this.state.showSaveAsTemplateWarning}
                                title={t("warning")}
                                onConfirm={() => this.onSave(this.TEMPLATE)}
                                onHide={() => this.setState({ showSaveAsTemplateWarning: false })}
                                text={t("template_warning")}
                                buttonText={t("Save")} />
                        </div>
                        <div className="p-2">
                            <button className="submit-btn-2" onClick={() => this.setState({ customLayout: false, forceLayout: true })}>Auto Layout</button>
                        </div>
                        <div className="p-2">
                            <button className="submit-btn-2" onClick={() => {
                                sessionStorage.removeItem("workflowState");
                                let newState = this.getClearState()
                                newState.loading = false
                                newState.forceLayout = true
                                this.setState(newState);
                            }}>{t("btnclear")}</button>
                        </div>
                    </div>
                    :
                    <div className="d-flex" style={{ justifyContent: 'space-between', flexDirection: 'row' }}>

                        <div className="col-6" style={{ justifyContent: 'space-between', flexDirection: 'column', padding: 0 }}>
                            {this.props.match.params.id ?
                                <WorkflowShares workflowId={this.props.match.params.id} />
                                : ""}
                            <div className="p-2">
                                <button className="submit-btn-2" onClick={() => this.setState({ customLayout: false, forceLayout: true })}>Auto Layout</button>
                            </div>
                            <div className="p-2">
                                <button className="submit-btn-2" onClick={() => {
                                    sessionStorage.removeItem("workflowState");
                                    let newState = this.getClearState()
                                    newState.loading = false
                                    newState.forceLayout = true
                                    this.setState(newState);
                                }}>{t("btnclear")}</button>
                            </div>
                        </div>

                        <div className="col-6" style={{ justifyContent: 'space-between', flexDirection: 'column', padding: 0 }}>
                            <div className="p-2" style={{ textAlign: 'right' }}>
                                <button className="submit-btn" onClick={this.onSave} disabled={!this.state.tested} id="saveButton">Save Workflow</button>
                            </div>
                            <div className="p-2" style={{ textAlign: 'right' }}>
                                <button className="submit-btn" onClick={() => this.onSave(this.DRAFT)} disabled={this.state.blocks.length <= 1}>Save Draft</button>
                            </div>
                            <div className="p-2" style={{ textAlign: 'right' }}>
                                <button className="submit-btn" onClick={() => this.onSave(this.TEMPLATE)} disabled={this.state.blocks.length <= 1}>Save as Template</button>
                            </div>
                        </div>
                    </div>

                }
                {this.state.onboarding ? <Joyride steps={this.onboarding[this.state.onboarding]} /> : <></>}
            </div>
        )
    }
}
export default withRouter(withTranslation()(Workflow), Workflow);